import './global';
import './shopify';

import '../features/bundle/scripts';
import '../features/countrySelector/scripts';
import '../features/disclosure/scripts';
import '../features/giftBox/scripts';
import '../features/mixAndMatch/scripts';
import '../features/product-add-to-cart-sticky/scripts';
import '../features/productBigImage/scripts';
import '../features/productDescription/scripts';
import '../features/upsell/scripts';
import '../features/upsellTracking/scripts';
